import axios from 'axios';
import { FLYER, NEWSPAPER, SHOWCASEREDUCED, SPECIAL, WEEKPROGRAMFLYER } from '../../constants/printType';


export const postCombinedPosterPdfCall = (apiUrl, posterUrlArray, format, landscape, margin, type, renderSleep = 500) => {
    if(type === FLYER) {
        return axios({
            method: 'POST',
            baseURL: apiUrl,
            url: '/page/pdf',
            data: {
                urls: posterUrlArray,
                renderOptions: {
                    renderSleep: renderSleep,
                    landscape: landscape,
                    width: '212mm',
                    height: '299mm',
                    printBackground: true,
                    margin: margin
                }
            }
        })
    } else if(type === WEEKPROGRAMFLYER && format === SPECIAL) {
        return axios({
            method: 'POST',
            baseURL: apiUrl,
            url: '/page/pdf',
            data: {
                urls: posterUrlArray,
                renderOptions: {
                    renderSleep: renderSleep,
                    landscape: landscape,
                    width: "244mm",
                    height: "346mm",
                    printBackground: true,
                    margin: margin
                }
            }
        })
    } else if(type === NEWSPAPER) {
        return axios({
            method: 'POST',
            baseURL: apiUrl,
            url: '/page/pdf',
            data: {
                urls: posterUrlArray,
                renderOptions: {
                    renderSleep: renderSleep,
                    landscape: landscape,
                    width: "150mm",
                    height: "319mm",
                    printBackground: true,
                    margin: margin
                }
            }
        })
    } else if(type === SHOWCASEREDUCED && format === SHOWCASEREDUCED) {
        return axios({
            method: 'POST',
            baseURL: apiUrl,
            url: '/page/pdf',
            data: {
                urls: posterUrlArray,
                renderOptions: {
                    renderSleep: renderSleep,
                    landscape: landscape,
                    width: "210mm",
                    height: "155mm",
                    printBackground: true,
                    margin: margin
                }
            }
        })
    } else {
        return axios({
            method: 'POST',
            baseURL: apiUrl,
            url: '/page/pdf',
            data: {
                urls: posterUrlArray,
                renderOptions: {
                    renderSleep: renderSleep,
                    landscape: landscape,
                    format: format,
                    printBackground: true,
                    margin: margin
                }
            }
        })
    }

}